<div class="body">
  <div class="left option" (click)="toggleSelection(0)" [ngClass]="{'selected': selectedToggle === 0}">
    <div class="leftContent" class="display-utils-only-gt-xs">
      <img src="assets/images/icons/subscribeIcon{{selectedToggle === 0 ? '_alt' : '' }}.svg" alt="">
    </div>
    <div class="rightContent" >
      <div class="title">Planos por Assinatura</div>
      <div class="subtitle display-utils-only-gt-xs">Pagamento mensal e mais economia</div>
    </div>
    <div class="higlight"><img src="assets/images/icons/percent.svg" alt=""> Melhor Opção</div>
  </div>
  <div class="right option" (click)="toggleSelection(1)" [ngClass]="{'selected': selectedToggle === 1}">
    <div class="leftContent" class="display-utils-only-gt-xs">
      <img src="assets/images/icons/packageIcon{{selectedToggle === 1 ? '_alt' : '' }}.svg" alt="">
    </div>
    <div class="rightContent" >
      <div class="title">Pacotes de Crédito</div>
      <div class="subtitle display-utils-only-gt-xs">Compre créditos quando precisar</div>
    </div>
  </div>
</div>
